import addGoogleMap from '../../scripts/app/google-map';
import addGoogleMapFacilities from '../../scripts/app/google-map-facilities';

// Facilities map

document.addEventListener('DOMContentLoaded', function () {
    // init map
    addGoogleMapFacilities('.jsFacilitiesMap');

    // retrigger filter change when tab with map is shown
    $("a[href='#facilitiesMapContent']").on('shown.bs.tab', function () {

        // once to init, second after timeout to retrigger zoom and markers
        $('.jsFacilities-Filter').trigger('change').trigger('change');
        setTimeout(() => {
            $('.jsFacilities-Filter').trigger('change');
        }, 100);
        
    });
});

// Central map

addGoogleMap('.jsCentralMap');
